import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["innerRef", "tabIndex", "placeholder", "align", "borderless", "width", "size", "error", "warning", "onValueChange", "disabled", "prefix", "suffix", "leftIcon", "rightIcon", "value", "onMouseDragStart", "onMouseDragEnd", "takeContentWidth", "aria-describedby"];

var _class, _class2, _temp; // TODO: Enable this rule in functional components.

/* eslint-disable @typescript-eslint/no-unused-vars */


import React from 'react';
import ReactDOM from 'react-dom';
import debounce from 'lodash.debounce';
import { globalObject } from '@skbkontur/global-object';
import { isFunction, isNonNullable } from "../../../lib/utils";
import { isKeyTab, isShortcutPaste } from "../../../lib/events/keyboard/identifiers";
import { MouseDrag } from "../../../lib/events/MouseDrag";
import { isEdge, isIE11, isMobile } from "../../../lib/client";
import { removeAllSelections, selectNodeContents } from "../../../lib/dom/selectionHelpers";
import { styles as jsInputStyles } from "../../../components/Input/Input.styles";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { findRenderContainer } from "../../../lib/listenFocusOutside";
import { rootNode } from "../../../lib/rootNode";
import { createPropsGetter } from "../../../lib/createPropsGetter";
import { isTheme2022 } from "../../../lib/theming/ThemeHelpers";
import { InputLayoutAside } from "../../../components/Input/InputLayout/InputLayoutAside";
import { InputLayoutContext, InputLayoutContextDefault } from "../../../components/Input/InputLayout/InputLayoutContext";
import { isInstanceOf } from "../../../lib/isInstanceOf";
import { FocusControlWrapper } from "../../FocusControlWrapper";
import { HiddenInput } from "../HiddenInput";
import { styles } from "../InputLikeText.styles";
export var InputLikeTextDataTids = {
  root: 'InputLikeText__root',
  input: 'InputLikeText__input',
  nativeInput: 'InputLikeText__nativeInput'
};
export var InputLikeText = rootNode(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InputLikeText, _React$Component);

  function InputLikeText() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.getProps = createPropsGetter(InputLikeText.defaultProps);
    _this.state = {
      blinking: false,
      focused: false
    };
    _this.node = null;
    _this.hiddenInput = null;
    _this.lastSelectedInnerNode = null;
    _this.frozen = false;
    _this.frozenBlur = false;
    _this.dragging = false;
    _this.selectNodeContentsDebounced = debounce(selectNodeContents, 0);

    _this.selectInnerNode = function (node, start, end) {
      if (start === void 0) {
        start = 0;
      }

      if (end === void 0) {
        end = 1;
      }

      if (_this.dragging || !node) {
        return;
      }

      if (isIE11 && globalObject.document && findRenderContainer(node, globalObject.document.body)) {
        // Code below causes Popup to close after triggering the focus event on the body in IE11
        return;
      }

      _this.frozen = true;
      _this.frozenBlur = true;
      _this.lastSelectedInnerNode = [node, start, end];

      _this.selectNodeContentsDebounced(node, start, end);

      if (_this.focusTimeout) {
        globalObject.clearInterval(_this.focusTimeout);
      }

      _this.focusTimeout = globalObject.setTimeout(function () {
        return (isIE11 || isEdge) && _this.node && _this.node.focus();
      }, 0);
    };

    _this.renderMain = function (props) {
      var _cx, _cx2, _cx3;

      var innerRef = props.innerRef,
          tabIndex = props.tabIndex,
          placeholder = props.placeholder,
          align = props.align,
          borderless = props.borderless,
          width = props.width,
          size = props.size,
          error = props.error,
          warning = props.warning,
          onValueChange = props.onValueChange,
          disabled = props.disabled,
          prefix = props.prefix,
          suffix = props.suffix,
          leftIcon = props.leftIcon,
          rightIcon = props.rightIcon,
          value = props.value,
          onMouseDragStart = props.onMouseDragStart,
          onMouseDragEnd = props.onMouseDragEnd,
          takeContentWidth = props.takeContentWidth,
          ariaDescribedby = props['aria-describedby'],
          rest = _objectWithoutPropertiesLoose(props, _excluded);

      var _this$state = _this.state,
          focused = _this$state.focused,
          blinking = _this$state.blinking;
      var leftSide = isTheme2022(_this.theme) ? /*#__PURE__*/React.createElement(InputLayoutAside, {
        icon: leftIcon,
        text: prefix,
        side: "left"
      }) : _this.renderLeftSide();
      var rightSide = isTheme2022(_this.theme) ? /*#__PURE__*/React.createElement(InputLayoutAside, {
        icon: rightIcon,
        text: suffix,
        side: "right"
      }) : _this.renderRightSide();
      var className = cx(styles.root(), jsInputStyles.root(_this.theme), _this.getSizeClassName(), (_cx = {}, _cx[jsInputStyles.disabled(_this.theme)] = !!disabled, _cx[jsInputStyles.borderless()] = !!borderless, _cx[jsInputStyles.focus(_this.theme)] = focused, _cx[jsInputStyles.hovering(_this.theme)] = !focused && !disabled && !warning && !error && !borderless, _cx[jsInputStyles.blink(_this.theme)] = blinking, _cx[jsInputStyles.warning(_this.theme)] = !!warning, _cx[jsInputStyles.error(_this.theme)] = !!error, _cx[jsInputStyles.focusFallback(_this.theme)] = focused && (isIE11 || isEdge), _cx[jsInputStyles.warningFallback(_this.theme)] = !!warning && (isIE11 || isEdge), _cx[jsInputStyles.errorFallback(_this.theme)] = !!error && (isIE11 || isEdge), _cx[jsInputStyles.hideBlinkingCursor()] = isMobile, _cx));
      var wrapperClass = cx(jsInputStyles.wrapper(), (_cx2 = {}, _cx2[styles.userSelectContain()] = focused, _cx2));
      var context = InputLayoutContextDefault;
      Object.assign(context, {
        disabled: disabled,
        focused: focused,
        size: size
      });
      return /*#__PURE__*/React.createElement(FocusControlWrapper, {
        disabled: disabled,
        onBlurWhenDisabled: _this.resetFocus
      }, /*#__PURE__*/React.createElement("span", _extends({
        "data-tid": InputLikeTextDataTids.root
      }, rest, {
        className: className,
        style: {
          width: width,
          textAlign: align
        },
        tabIndex: disabled ? undefined : 0,
        onFocus: _this.handleFocus,
        onBlur: _this.handleBlur,
        ref: _this.innerRef,
        onKeyDown: _this.handleKeyDown,
        onMouseDown: _this.handleMouseDown
      }), /*#__PURE__*/React.createElement(InputLayoutContext.Provider, {
        value: context
      }, /*#__PURE__*/React.createElement("input", {
        "data-tid": InputLikeTextDataTids.nativeInput,
        type: "hidden",
        value: value,
        disabled: disabled,
        "aria-describedby": ariaDescribedby
      }), leftSide, /*#__PURE__*/React.createElement("span", {
        className: wrapperClass
      }, /*#__PURE__*/React.createElement("span", {
        "data-tid": InputLikeTextDataTids.input,
        className: cx(jsInputStyles.input(_this.theme), (_cx3 = {}, _cx3[styles.absolute()] = !takeContentWidth, _cx3[jsInputStyles.inputFocus(_this.theme)] = focused, _cx3[jsInputStyles.inputDisabled(_this.theme)] = disabled, _cx3))
      }, _this.props.children), _this.renderPlaceholder()), rightSide, isIE11 && focused && /*#__PURE__*/React.createElement(HiddenInput, {
        nodeRef: _this.hiddenInputRef
      }))));
    };

    _this.renderLeftIcon = function () {
      return _this.renderIcon(_this.props.leftIcon, _this.getIconClassname());
    };

    _this.renderRightIcon = function () {
      return _this.renderIcon(_this.props.rightIcon, _this.getIconClassname(true));
    };

    _this.renderIcon = function (icon, className) {
      var _cx4;

      if (!icon) {
        return null;
      }

      var disabled = _this.props.disabled;
      var iconNode = isFunction(icon) ? icon() : icon;
      return /*#__PURE__*/React.createElement("span", {
        className: cx(jsInputStyles.icon(), className, jsInputStyles.useDefaultColor(_this.theme), (_cx4 = {}, _cx4[jsInputStyles.iconDisabled(_this.theme)] = disabled, _cx4))
      }, iconNode);
    };

    _this.renderPrefix = function () {
      var _cx5;

      var _this$props = _this.props,
          prefix = _this$props.prefix,
          disabled = _this$props.disabled;

      if (!prefix) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        className: cx(jsInputStyles.prefix(_this.theme), (_cx5 = {}, _cx5[jsInputStyles.prefixDisabled(_this.theme)] = disabled, _cx5))
      }, prefix);
    };

    _this.renderSuffix = function () {
      var _cx6;

      var _this$props2 = _this.props,
          suffix = _this$props2.suffix,
          disabled = _this$props2.disabled;

      if (!suffix) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        className: cx(jsInputStyles.suffix(_this.theme), (_cx6 = {}, _cx6[jsInputStyles.suffixDisabled(_this.theme)] = disabled, _cx6))
      }, suffix);
    };

    _this.renderLeftSide = function () {
      var leftIcon = _this.renderLeftIcon();

      var prefix = _this.renderPrefix();

      if (!leftIcon && !prefix) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        className: jsInputStyles.sideContainer()
      }, leftIcon, prefix);
    };

    _this.renderRightSide = function () {
      var rightIcon = _this.renderRightIcon();

      var suffix = _this.renderSuffix();

      if (!rightIcon && !suffix) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        className: cx(jsInputStyles.sideContainer(), jsInputStyles.rightContainer())
      }, rightIcon, suffix);
    };

    _this.renderPlaceholder = function () {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          placeholder = _this$props3.placeholder,
          disabled = _this$props3.disabled;
      var focused = _this.state.focused;
      var hasValue = isNonNullable(children) && children !== '';

      if (!hasValue && placeholder) {
        var _cx7;

        return /*#__PURE__*/React.createElement("span", {
          className: cx(jsInputStyles.placeholder(_this.theme), (_cx7 = {}, _cx7[jsInputStyles.placeholderDisabled(_this.theme)] = disabled, _cx7[jsInputStyles.placeholderFocus(_this.theme)] = focused, _cx7))
        }, placeholder);
      }

      return null;
    };

    _this.handleDocumentMouseDown = function (e) {
      if (_this.state.focused && _this.node && isInstanceOf(e.target, globalObject.Node) && !_this.node.contains(e.target)) {
        _this.defrost();
      }
    };

    _this.handleDocumentKeyDown = function (e) {
      if (_this.state.focused && isKeyTab(e)) {
        _this.defrost();
      }
    };

    _this.handleMouseDown = function () {
      _this.frozen = true;
    };

    _this.handleKeyDown = function (e) {
      if (_this.props.disabled) {
        return;
      }

      if (isIE11 && isShortcutPaste(e) && _this.hiddenInput) {
        _this.frozen = true;
        globalObject.setTimeout(function () {
          if (_this.lastSelectedInnerNode) {
            var _this2;

            (_this2 = _this).selectInnerNode.apply(_this2, _this.lastSelectedInnerNode);
          }

          if (_this.node) {
            _this.node.focus();
          }
        }, 0);

        _this.hiddenInput.focus();
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleMouseDragStart = function (e) {
      var _globalObject$documen;

      _this.dragging = true;
      (_globalObject$documen = globalObject.document) == null ? void 0 : _globalObject$documen.documentElement.classList.add(styles.userSelectNone());

      if (_this.props.onMouseDragStart) {
        _this.props.onMouseDragStart(e);
      }
    };

    _this.handleMouseDragEnd = function (e) {
      var _globalObject$documen2; // Дожидаемся onMouseUp


      globalObject.setTimeout(function () {
        _this.dragging = false;

        if (_this.props.onMouseDragEnd) {
          _this.props.onMouseDragEnd(e);
        }
      }, 0);
      (_globalObject$documen2 = globalObject.document) == null ? void 0 : _globalObject$documen2.documentElement.classList.remove(styles.userSelectNone());
    };

    _this.handleFocus = function (e) {
      if (isMobile) {
        var _this$node;

        (_this$node = _this.node) == null ? void 0 : _this$node.setAttribute('contenteditable', 'true');
      }

      if (_this.props.disabled) {
        if (isIE11 && globalObject.document) {
          selectNodeContents(globalObject.document.body, 0, 0);
        }

        return;
      }

      if ((isIE11 || isEdge) && _this.frozen) {
        _this.frozen = false;

        if (_this.state.focused) {
          return;
        }
      } // Auto-batching React@18 creates problems that are fixed with flushSync
      // https://github.com/skbkontur/retail-ui/pull/3144#issuecomment-1535235366


      if (React.version.search('18') === 0) {
        ReactDOM.flushSync(function () {
          return _this.setState({
            focused: true
          });
        });
      } else {
        _this.setState({
          focused: true
        });
      }

      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    };

    _this.resetFocus = function () {
      _this.selectNodeContentsDebounced.cancel();

      if (isMobile) {
        var _this$node2;

        (_this$node2 = _this.node) == null ? void 0 : _this$node2.removeAttribute('contenteditable');
      }

      if ((isIE11 || isEdge) && _this.frozenBlur) {
        _this.frozenBlur = false;
      }

      removeAllSelections();

      _this.setState({
        focused: false
      });
    };

    _this.handleBlur = function (e) {
      _this.selectNodeContentsDebounced.cancel();

      if (isMobile) {
        var _this$node3;

        (_this$node3 = _this.node) == null ? void 0 : _this$node3.removeAttribute('contenteditable');
      }

      if (_this.props.disabled) {
        e.stopPropagation();
        return;
      }

      if ((isIE11 || isEdge) && _this.frozenBlur) {
        _this.frozenBlur = false;
        return;
      }

      if ((isIE11 || isEdge) && _this.frozen) {
        return;
      }

      removeAllSelections();

      _this.setState({
        focused: false
      });

      _this.props.onBlur == null ? void 0 : _this.props.onBlur(e);
    };

    _this.hiddenInputRef = function (el) {
      _this.hiddenInput = el;
    };

    _this.innerRef = function (el) {
      if (_this.props.innerRef) {
        _this.props.innerRef(el);
      }

      _this.node = el;
    };

    _this.defrost = function () {
      _this.frozen = false;
      _this.frozenBlur = false;
    };

    _this.getSizeClassName = function () {
      var _cx8, _cx9, _cx10;

      switch (_this.getProps().size) {
        case 'large':
          return cx((_cx8 = {}, _cx8[jsInputStyles.sizeLarge(_this.theme)] = true, _cx8[jsInputStyles.sizeLargeFallback(_this.theme)] = isIE11 || isEdge, _cx8));

        case 'medium':
          return cx((_cx9 = {}, _cx9[jsInputStyles.sizeMedium(_this.theme)] = true, _cx9[jsInputStyles.sizeMediumFallback(_this.theme)] = isIE11 || isEdge, _cx9));

        case 'small':
        default:
          return cx((_cx10 = {}, _cx10[jsInputStyles.sizeSmall(_this.theme)] = true, _cx10[jsInputStyles.sizeSmallFallback(_this.theme)] = isIE11 || isEdge, _cx10));
      }
    };

    return _this;
  }

  var _proto = InputLikeText.prototype;
  /**
  * @public
  */

  _proto.focus = function focus() {
    if (this.node) {
      this.node.focus();
    }
  }
  /**
  * @public
  */
  ;

  _proto.blur = function blur() {
    if (this.node) {
      this.node.blur();
    }
  }
  /**
  * @public
  */
  ;

  _proto.blink = function blink() {
    var _this3 = this;

    if (this.props.disabled) {
      return;
    }

    this.setState({
      blinking: true
    }, function () {
      _this3.blinkTimeout = globalObject.setTimeout(function () {
        return _this3.setState({
          blinking: false
        });
      }, 150);
    });
  };

  _proto.getNode = function getNode() {
    return this.node;
  } // Async call required for Firefox
  ;

  _proto.componentDidMount = function componentDidMount() {
    var _globalObject$documen3, _globalObject$documen4;

    if (this.node) {
      MouseDrag.listen(this.node).onMouseDragStart(this.handleMouseDragStart).onMouseDragEnd(this.handleMouseDragEnd);
    }

    (_globalObject$documen3 = globalObject.document) == null ? void 0 : _globalObject$documen3.addEventListener('mousedown', this.handleDocumentMouseDown);
    (_globalObject$documen4 = globalObject.document) == null ? void 0 : _globalObject$documen4.addEventListener('keydown', this.handleDocumentKeyDown);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _globalObject$documen5, _globalObject$documen6;

    if (this.blinkTimeout) {
      globalObject.clearTimeout(this.blinkTimeout);
    }

    MouseDrag.stop(this.node);
    (_globalObject$documen5 = globalObject.document) == null ? void 0 : _globalObject$documen5.removeEventListener('mousedown', this.handleDocumentMouseDown);
    (_globalObject$documen6 = globalObject.document) == null ? void 0 : _globalObject$documen6.removeEventListener('keydown', this.handleDocumentKeyDown);
  };

  _proto.render = function render() {
    var _this4 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this4.theme = theme;
      return /*#__PURE__*/React.createElement(CommonWrapper, _extends({
        rootNodeRef: _this4.setRootNode
      }, _this4.props), _this4.renderMain);
    });
  };

  _proto.getIconClassname = function getIconClassname(right) {
    if (right === void 0) {
      right = false;
    }

    switch (this.getProps().size) {
      case 'large':
        return right ? jsInputStyles.rightIconLarge(this.theme) : jsInputStyles.leftIconLarge(this.theme);

      case 'medium':
        return right ? jsInputStyles.rightIconMedium(this.theme) : jsInputStyles.leftIconMedium(this.theme);

      case 'small':
      default:
        return right ? jsInputStyles.rightIconSmall(this.theme) : jsInputStyles.leftIconSmall(this.theme);
    }
  };

  return InputLikeText;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'InputLikeText', _class2.displayName = 'InputLikeText', _class2.defaultProps = {
  size: 'small'
}, _temp)) || _class;